import React, { useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ImageWithBasePath from "../../../../core/img/imagewithbasebath";
import { Link, useNavigate } from "react-router-dom";
// import { all_routes } from "../../../../Router/all_routes";
import { RotateCcw } from "feather-icons-react/build/IconComponents";

import Table from "../../../../core/pagination/datatable";
import { Select, Spin } from "antd";
import {
  ROLL_CALL_API_BASE_URL,
} from "../RollCallConfig/RollCallConfig";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import 'jspdf-autotable';


const LeaveSummary = () => {

  const years = [2024, 2025];

  const [selectedEmp, setSelectedEmp] = useState(null);
  const [selectedYear, setSelectedYear] = useState(null);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [leavedata, SetleaveData] = useState([]);

  const [employees, setEmployees] = useState([]);
  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    const superId = sessionStorage.getItem("superId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found in sessionStorage");
      navigate("/signin");
    }
  }, [navigate]);

  useEffect(() => {
    if (tokenData && superIdData) {
      console.log("Token:", tokenData);
      console.log("SuperId:", superIdData);
    }
  }, [tokenData, superIdData]);


  useEffect(() => {
    if (tokenData && superIdData) {
      const fetchEmployeeData = async () => {
        try {
          const response = await fetch(
            `${ROLL_CALL_API_BASE_URL}portal/emp/getEmployee?superid=${superIdData}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${tokenData}`,
              },
            }
          );

          if (!response.ok) throw new Error("Failed to fetch employees");

          const data = await response.json();
          if (data.status) setEmployees(data.ResultData || []);
          else console.error("Error fetching employees:", data.ErrorMsg);
        } catch (error) {
          console.error("Error fetching employees:", error);
        }
      };

      fetchEmployeeData();
    }
  }, [tokenData, superIdData]);

  const empOptions = employees.map((emp) => ({
    value: emp.regid,
    label: emp.UserName,
  }));

  const handleLeavessView = async () => {

    setLoading(true);
    if (tokenData) {
      try {
        const response = await fetch(
          `${ROLL_CALL_API_BASE_URL}portal/leave/getleaveaccruals?regid=${selectedEmp}&year=${selectedYear}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${tokenData}`,
            },
          }
        );

        const data = await response.json();

        if (data?.status) {
          SetleaveData(data.ResultData || []);
        } else {
          console.error(
            "Failed to fetch employees:",
            data?.ErrorMsg || response.statusText
          );
        }
      } catch (error) {
        console.error("Error fetching employees:", error.message);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleLeavesView = async () => {

    setLoading(true);
    if (tokenData) {
      try {
        const response = await fetch(
          `${ROLL_CALL_API_BASE_URL}portal/leave/getleavesummary?regid=${selectedEmp}&year=${selectedYear}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${tokenData}`,
            },
          }
        );

        const data = await response.json();

        if (data?.status) {
          setData(data.ResultData || []);
        } else {
          console.error(
            "Failed to fetch employees:",
            data?.ErrorMsg || response.statusText
          );
        }
      } catch (error) {
        console.error("Error fetching employees:", error.message);
      } finally {
        setLoading(false);
      }
    }
  };


  const submitData = async () => {
    await handleLeavesView();
    await handleLeavessView();
  }


  const filteredData = data.filter((item) => {
    return (
      (item.UserName && item.UserName.toLowerCase()) ||
      (item.Comments && item.Comments.toLowerCase()) ||
      (item.LvCode && item.LvCode.toString())
    );
  });

  const columns = [
    {
      title: "Id",
      dataIndex: "sno",
      sorter: (a, b) => a.sno - b.sno,
      render: (_, __, index) => index + 1,
    },
    {
      title: "Employee",
      dataIndex: "UserName",
      sorter: (a, b) => (a.UserName?.length || 0) - (b.UserName?.length || 0),
      render: (text) =>
        <span>
          {text?.length > 15 ? `${text.substring(0, 15)}...` : text}
        </span>
    },
    {
      title: "Leave Count",
      dataIndex: "LeaveCount",
      sorter: (a, b) => (a.LeaveCount || 0) - (b.LeaveCount || 0),
    },
    {
      title: "Type",
      dataIndex: "LeaveTypeName",
      sorter: (a, b) => (a.LeaveTypeName?.length || "") - (b.LeaveTypeName?.length || ""),
    },
    {
      title: "Start Date",
      dataIndex: "StartDt",
      sorter: (a, b) => new Date(a.StartDt) - new Date(b.StartDt),
      render: (date) => date ? new Date(date).toLocaleDateString("en-GB") : "",
    },
    {
      title: "End Date",
      dataIndex: "EndDt",
      sorter: (a, b) => (a.EndDt?.length || 0) - (b.EndDt?.length || 0),
      render: (date) => date ? new Date(date).toLocaleDateString("en-GB") : "",
    },
    {
      title: "Comments",
      dataIndex: "Comments",
      sorter: (a, b) => (a.Comments?.length || 0) - (b.Comments?.length || 0),
      render: (text) =>
        <span>
          {text?.length > 15 ? `${text.substring(0, 15)}...` : text}
        </span>
    },
  ];


  const handleReload = () => {
    window.location.reload();
  };

  const generatePDF = () => {

    if (filteredData && filteredData.length === 0) {
      return;
    }
    const doc = new jsPDF();
   
    doc.text("Leave Data Report", 14, 10);

    const tableColumn = ["S.No", "Employee", "Type", "Start Date", "End Date", "Comments"];
    const tableRows = filteredData.map((item, index) => [
      index + 1,
      item.UserName || "N/A",
      item.LvCode === "SL" ? "Sick" : item.LvCode === "EL" ? "Earned" : item.LvCode === "CL" ? "Casual" : item.LvCode === "OL" ? "Optional" : item.LvCode || "N/A",
      item.StartDt || "N/A",
      item.EndDt || "N/A",
      item.Comments || "N/A",
    ]);

    doc.autoTable({ head: [tableColumn], body: tableRows, startY: 20 });
    doc.save("Leave_Data.pdf");
  };

  const handleDownloadExcel = () => {
    if (filteredData && filteredData.length === 0) {
      return;
    }

    const wb = XLSX.utils.book_new();
    const wsData = filteredData.map((item, index) => ({
      "S.No": index + 1,
      "Employee": item.UserName || "N/A",
      "Type": item.LvCode || "N/A",
      "Start Date": item.StartDt || "N/A",
      "End Date": item.EndDt || "N/A",
      "Comments": item.Comments || "N/A",
    }));

    const ws = XLSX.utils.json_to_sheet(wsData);
    XLSX.utils.book_append_sheet(wb, ws, "Leave Data");
    XLSX.writeFile(wb, "Leave_Data.xlsx");
  };




  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );
  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );
  // const renderCollapseTooltip = (props) => (
  //   <Tooltip id="refresh-tooltip" {...props}>
  //     Collapse
  //   </Tooltip>
  // );

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/rollcall/dashboard">
                      <i className="fas fa-home fa-lg" />
                    </Link>
                  </li>
                  <h4 className="breadcrumb-item " aria-current="page">
                    Leave Summary
                  </h4>
                </ol>
              </nav>
              <h6>Find your Leave Summary here</h6>
            </div>
          </div>
          <ul className="table-top-head">
            <li>
              <OverlayTrigger placement="top" overlay={renderTooltip}>
                <Link
                  onClick={() => generatePDF()} // Trigger on click
                  style={{ cursor: "pointer" }}
                >
                  <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                <Link data-bs-toggle="tooltip" data-bs-placement="top"
                  onClick={() => handleDownloadExcel()} // Trigger on click
                  style={{ cursor: "pointer" }}
                >
                  <ImageWithBasePath
                    src="assets/img/icons/excel.svg"
                    alt="img"
                  />
                </Link>
              </OverlayTrigger>
            </li>

            <li onClick={handleReload}>
              <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                <Link data-bs-toggle="tooltip" data-bs-placement="top">
                  <RotateCcw />
                </Link>
              </OverlayTrigger>
            </li>
            {/* <li>
              <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  id="collapse-header"
                  className={data ? "active" : ""}
                  onClick={(e) => {
                    e.preventDefault();
                    dispatch(setToogleHeader(!data));
                  }}
                >
                  <ChevronUp />
                </Link>
              </OverlayTrigger>
            </li> */}
          </ul>
        </div>
        {/* /product list */}
        <div className="card table-list-card">
          <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
            <div className="search-set"></div>
            <div className="d-flex right-content align-items-end row">
              <div className="form-control p-0 border-0" style={{ width: 180 }}>
                <div className="col-5 " >

                  <Select
                    showSearch
                    placeholder="Choose Employee"
                    value={selectedEmp}
                    onChange={setSelectedEmp}
                    options={empOptions}
                    allowClear
                    style={{ width: 170, height: 37 }}
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                  />
                </div>
              </div>
              <div className="form-control p-0 border-0" style={{ width: 100 }}>
                <div className="col-3 ">

                  <Select
                    placeholder="Year"
                    style={{ width: 100, height: 37 }}
                    onChange={(value) => {
                      setSelectedYear(value);

                    }}
                  >
                    {years.map((year) => (
                      <Select.Option key={year} value={year}>
                        {year}
                      </Select.Option>
                    ))}
                  </Select>
                </div>
              </div>
              <div className="col-2">
                <button className="btn btn-primary" onClick={submitData}>
                  <FontAwesomeIcon icon={faMagnifyingGlass} />
                </button>
              </div>
            </div>
          </div>
          <div className="d-flex row  justify-content-between m-2">
            <div className="col-2 d-flex">
              <div className="card revenue-widget flex-fill border border-secondary">
                <div className="card-body p-2">
                  <div className="d-flex align-items-center justify-content-between">
                    <div>
                      <h4 className="mb-">{leavedata?.CarryForwardLeaves || 0}</h4>
                      <p className="m-0">Carry Forward</p>

                    </div>
                    <span className="revenue-icon bg-cyan-transparent text-cyan">
                      <i className="fa-solid fa-forward-step fs-16"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-2 d-flex">
              <div className="card revenue-widget flex-fill border border-success">
                <div className="card-body p-2">
                  <div className="d-flex align-items-center justify-content-between">
                    <div>
                      <h4 className="mb-1">{leavedata?.Accrued || 0}</h4>
                      <p>Accrued</p>
                    </div>
                    <span className="revenue-icon bg-teal-transparent text-teal">
                      <i className="fa-solid fa-layer-group fs-16" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-2 d-flex">
              <div className="card revenue-widget flex-fill border border-danger">
                <div className="card-body p-2">
                  <div className="d-flex align-items-center justify-content-between">
                    <div>
                      <h4 className="mb-1">{leavedata?.Taken || 0}</h4>
                      <p>Used</p>
                    </div>
                    <span className="revenue-icon bg-orange-transparent text-orange">
                      <i className="fa-solid fa-list-check fs-16"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-2 d-flex">
              <div className="card revenue-widget flex-fill border border-info">
                <div className="card-body p-2">
                  <div className="d-flex align-items-center justify-content-between">
                    <div>
                      <h4 className="mb-1">{leavedata?.Balance || 0}</h4>
                      <p>Balance</p>
                    </div>
                    <span className="revenue-icon bg-indigo-transparent text-indigo">
                      <i className="fa-solid fa-list-ul fs-16"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-2 d-flex">
              <div className="card revenue-widget flex-fill border border-success">
                <div className="card-body p-2">
                  <div className="d-flex align-items-center justify-content-between">
                    <div>
                      <h4 className="mb-1">{leavedata?.approved || 0}</h4>
                      <p>Approved</p>
                    </div>
                    <span className="revenue-icon bg-indigo-transparent text-indigo">
                      <i className="fa-solid fa-check-double fs-16"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-2 d-flex">
              <div className="card revenue-widget flex-fill border border-warning">
                <div className="card-body p-2">
                  <div className="d-flex align-items-center justify-content-between">
                    <div>
                      <h4 className="mb-1">{leavedata?.pending || 0}</h4>
                      <p>Pending</p>
                    </div>
                    <span className="revenue-icon bg-indigo-transparent text-indigo">
                      <i className="fa-solid fa-hourglass-half fs-16"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card-body">
            <div className="table-responsive">
              {loading ? (
                <div className="text-center my-4">
                  <Spin size="large" />
                  <p>Loading data...</p>
                </div>
              ) : (
                <div className="table-responsive brand-table">
                  <Table columns={columns} dataSource={filteredData} />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeaveSummary;
